import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  Status,
} from "../../../../features/admin/document/document/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();

  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const country = useSelector((state) => state.document.document);

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = country?.current_page) => {
    // await dispatch(AllCountry());
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: country?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      setModalMessage("Deleted Successfully");
      setModalShow(true);
      await fetch();
      return true; // Success
    } catch (error) {
      setModalMessage("Delete Failed");
      setModalShow(true);
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      const res = await dispatch(Status(id));
      if (res.payload?.data?.success) {
        await fetch();
        setModalShow(true);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    country,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    modalMessage,
    modalShow,
    setModalShow,
  };
};
